import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=4d2b5868&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=ts"
export * from "./PreviewImage.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PreviewImage.vue?vue&type=style&index=0&id=4d2b5868&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4d2b5868",
  "2517bedd"
  
)

export default component.exports